module.exports = __webpack_public_path__ + "static/media/call-icon.ed4ee4ca.png";